import { SET_USER, LOGOUT_USER, FORCE_LOGOUT_USER, SET_ANONYMOUS_USER } from '../actionsList';
import Cookies from 'universal-cookie';
// import { initSocket } from '../../utils/socket.services';
import { init } from '../../utils/init.services';
import socketServices from '../../utils/socket.services';
const cookies = new Cookies();


function loginUser(state, action) {
    let auth = action.auth
    if (auth) {
        cookies.set('token', auth.token, { path: '/' })
        setTimeout(() => {
            init()
        }, 200);
    }
}


function logoutUser(action) {
    // let auth = action.auth
    // if (auth?.token) {
    cookies.remove('token', { path: '/' })
    setTimeout(() => {
        // init()
    }, 200);

    // }
}
function setAnonymousUserInfo(action) {
    // console.log('setAnonymousUserInfoMiddle')
    let token = action.token
    if (token) {
        cookies.set('AN-token', token, { path: '/' })
        setTimeout(() => {
            socketServices.initSocket()
        }, 200);
    }
}

const user = store => next => action => {
    let result = next(action)
    if (action.type === SET_USER) {
        loginUser(store.getState(), action)
    }
    if (action.type === SET_ANONYMOUS_USER) {
        setAnonymousUserInfo(action)
    }
    if (action.type === LOGOUT_USER || action.type === FORCE_LOGOUT_USER) {
        logoutUser(action)
    }
    return result
}

export default user;